export default {
    user:{
        phone:''
    },
    usercenter:{
        true_name:'',
        is_admin:'',
        account_type:'',
        doctor_id:''
    },
    company:{
        logo:'',
        name:''
    },
    validator:{
        empty:{
            reg:/^\s*$/,
            error:'不能为空'
        },
        phone:{
            reg:/^((13[0-9])|(14[4-9])|(15[0-3,5-9])|(17[0-8])|(18[0-9])|(16[2,5-7])|(19[0-9]))\d{8}$/,
            error:'请输入正确的手机号'
        },
        moblie:{
        	reg:/^0\d{2,3}-?\d{7,8}$/,
        	error:'请输入正确的电话'
        },
        chinese:{
            reg:/[^\u4E00-\u9FA5]/g,
            error:'请输入中文'
        }
    },
    /*锁屏状态*/
    lockStatus:false,
    /*预约modal*/
    appointModal:{
        open:false,
        data:{}
    },
    /*挂号modal*/
    regModal:{
        open:false,
        data:{}
    },
    /*当前操作的患者信息*/
    patient:{
    
    },
    /* 病例的牙齿信息 */
    teethInfoArr:{
        
    },

    /*webSocket状态*/
    wSocket:{

    },
    // 方案白名单手机号列表，如果是白名单内的账号，查看方案只会打开dx，不会打开旧的web3D页面
    planWhitePhones: []
}



// WEBPACK FOOTER //
// ./src/vuex/state.js